import { LazyQueryHookOptions, QueryHookOptions } from '@apollo/client';
import {
  OfferQuery,
  useOfferQuery,
  useOfferLazyQuery,
  OfferSelectListQuery,
  OfferSelectListQueryVariables,
  useOfferSelectListLazyQuery,
  OfferQueryVariables,
} from '@occc/graphql';

import { useLazyQuery } from '../utils';

export const useGetOfferById = (
  idEquals: string | undefined,
  chainIdEquals?: string,
  baseOptions?: QueryHookOptions<OfferQuery, OfferQueryVariables>,
) => {
  const response = useOfferQuery({
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    variables: {
      filter: {
        idEquals,
        ...(chainIdEquals ? { chainIdEquals } : {}),
      },
    },
    skip: !idEquals,
    ...baseOptions,
  });

  const node = response.data?.offers.edges[0]?.node;

  return {
    ...response,
    data: node,
  };
};

export const useGetOfferByIds = (
  idContains: string[],
  chainIdEquals?: string,
  baseOptions?: QueryHookOptions<OfferQuery, OfferQueryVariables>,
) => {
  const response = useOfferQuery({
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    variables: {
      filter: {
        idContains,
        ...(chainIdEquals ? { chainIdEquals } : {}),
      },
    },
    ...baseOptions,
  });

  const data = response.data?.offers.edges.map((edge) => edge.node);

  return {
    ...response,
    data,
  };
};

export const useGetOfferByIdLazy = (
  chainIdEquals?: string,
  baseOptions?: QueryHookOptions<OfferQuery, OfferQueryVariables>,
) => {
  const [query] = useOfferLazyQuery({
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    variables: {
      filter: {
        ...(chainIdEquals ? { chainIdEquals } : {}),
      },
    },
    ...baseOptions,
  });

  const fetch = async (idEquals: string) => {
    const response = await query({
      variables: {
        filter: {
          idEquals,
        },
      },
    });

    const node = response.data?.offers.edges[0]?.node;

    return {
      ...response,
      data: node,
    };
  };

  return [fetch];
};

export const useGetOfferSelectListLazy = (
  baseOptions?: LazyQueryHookOptions<OfferSelectListQuery, OfferSelectListQueryVariables>,
) => {
  const [executeQuery, response] = useLazyQuery(useOfferSelectListLazyQuery, baseOptions);

  return {
    executeQuery,
    response: {
      ...response,
      data: response.data ? response.data.offers.edges.map((item) => item.node) : response.data,
    },
  };
};
